<h2 mat-dialog-title>Selecione os teste</h2>
<mat-dialog-content>

    <p class="mat-body-1">Selecione os testes para aplicar aos candidatos selecionados</p>

    <mat-selection-list #selectionTestList>
        <mat-list-option *ngFor="let test of tests" [value]="test.id">
            <h3 matLine>{{ test.name }}</h3>
            <p matLine>{{ test.description }}</p>
        </mat-list-option>
    </mat-selection-list>

</mat-dialog-content>
<!-- <mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar> -->
<mat-dialog-actions>
    <button mat-dialog-close mat-button color="accent">Fechar</button>
    <button mat-raised-button (click)="submit()" color="primary">Continuar</button>
</mat-dialog-actions>